module.exports = __webpack_public_path__ + "static/media/customerDeclined.e2ef5cd2.png";